const TOUR_STORAGE_PREFIX = "aq_qms_doc_lib_tour_v1";

export function getQmsDocLibTourStorageKey(staffId) {
  const id = String(staffId || "").trim();
  return id ? `${TOUR_STORAGE_PREFIX}_${id}` : TOUR_STORAGE_PREFIX;
}

export function hasCompletedQmsDocLibTour(staffId) {
  try {
    return localStorage.getItem(getQmsDocLibTourStorageKey(staffId)) === "1";
  } catch {
    return false;
  }
}

export function markQmsDocLibTourCompleted(staffId) {
  try {
    localStorage.setItem(getQmsDocLibTourStorageKey(staffId), "1");
  } catch {
    /* ignore quota errors */
  }
}
